import { useEffect, FC, useState } from 'react';
import { EftFundingTransactionResponse, LinkedTransactionsMap } from 'vopay';
import useFetchEFTFundTransaction from '@/hooks/useApi/useFetchEFTFundTransaction';
import EftFundingTransactionInfo from './EftFundingTransactionInfo';
import LinkedTransactionInfo from './LinkedTransactionInfo';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';

type EftFundingTransactionProps = {
  TransactionID: string;
  Notes: string;
  isParent?: boolean;
  jwt: string;
  ELinxRequestID?: string;
};

const EftFundingTransactionContainer: FC<EftFundingTransactionProps> = ({
  TransactionID,
  Notes,
  isParent = false,
  jwt,
  ELinxRequestID = '',
}) => {
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<EftFundingTransactionResponse>();
  const [eftFundTransaction, getEftFundTransaction, resetTransactionsId] = useFetchEFTFundTransaction({ bearer: jwt });
  const [isDataFeched, setIsDataFeched] = useState(false);
  const [parentTransactions, setParentTransactions] = useState<LinkedTransactionsMap>();
  const { userSettings } = useUserSettingsProvider();

  useEffect(() => {
    getEftFundTransaction({ TransactionID, Timezone: userSettings.timezone });
    setIsDataFeched(true);
  }, [currentTransactionId, TransactionID]);

  useEffect(() => {
    if (eftFundTransaction) {
      setTransaction(eftFundTransaction);
    }
  }, [eftFundTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
    resetTransactionsId();
  }
  useEffect(() => {
    if (isDataFeched && Object.values(eftFundTransaction).length > 0 && eftFundTransaction.SubTransactions) {
      const subTransactionsList: LinkedTransactionsMap = Object.values(eftFundTransaction.SubTransactions);

      setParentTransactions(subTransactionsList);
    }
  }, [eftFundTransaction]);

  return (
    <div>
      {transaction && (
        <EftFundingTransactionInfo transaction={transaction} Notes={Notes} isParent={isParent} jwt={jwt} ELinxRequestID={ELinxRequestID} />
      )}
      {parentTransactions && (
        <LinkedTransactionInfo LinkedTransactions={parentTransactions} Currency={transaction?.Currency || 'CAD'} />
      )}
    </div>
  );
};

export default EftFundingTransactionContainer;
